export default {
    watchers: {
        illegalName: 'Illegal Name ( cannot contain "/" )',
        hasSpaces: 'Illegal Name (cannot contain spaces)'
    },
    webhooks: {
        illegalName: 'Illegal Name ( cannot contain "/" )',
        hasSpaces: 'Illegal Name (cannot contain spaces)'
    },
    url: {

        localHosturl: 'localhost url is not allowed',
        validUrl: 'URL is not valid',
        aolUrl: 'Artifactory Online mode - please use server name only',
        illegalName: 'Illegal ID ( cannot contain "::")',
        hasSpaces: 'Illegal Name (cannot contain spaces)'
    },
    users: {
        pwdNotStrong: `Password does not match policy: password should include a number, upper case character and at least 8 characters length`,
        emailValid: `Please enter a valid email`,
        pwdNoMatch: `Password does not match`,
        hasSpaces: 'Illegal Name (cannot contain spaces)',
        specialChar:'Name cannot be blank or contain /\\:|?*"<>'
    },
    policy: {
        name: `Policy name already exist`,
        illegalName: 'Illegal Name ( cannot contain "/" )',
        hasSpaces: 'Illegal Name (cannot contain spaces)'
    },
    rule: {
        name: `Rule name already exist`,
        illegalName: 'Illegal Name ( cannot contain "/" )',
        hasSpaces: 'Illegal Name (cannot contain spaces)'
    },
    components: {
        cve: 'Invalid CVE format - Filter will not be applied'
    }
};




// WEBPACK FOOTER //
// ./modules/xray/constants/validation.constants.js